module.exports = __webpack_public_path__ + "img/wheel - copia.e9ed224d.png";